export default class ClearFormatting {
  static get isInline() {
    return true;
  }

  constructor({ api }) {
    this.api = api;
    this.button = null;
  }

  render() {
    this.button = document.createElement("button");
    this.button.type = "button";
    this.button.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
        <path fill="currentColor" d="M10 4h4v2h-4V4zm-1 3h6l1 3H8l1-3zm-2.5 4h11l-1.5 8h-8L6.5 11zm7.12 2H10.4l-.4 4h4l-.38-4z"/>
      </svg>
    `;
    this.button.classList.add("cdx-inline-tool");

    this.button.title = "Formatierung zurücksetzen (🧽)";

    this.button.addEventListener("click", async () => {
      const index = this.api.blocks.getCurrentBlockIndex();
      const block = this.api.blocks.getBlockByIndex(index);

      if (!block) return;

      const text = block.data?.text || "";

      await this.api.blocks.delete(index);
      await this.api.blocks.insert("paragraph", { text }, index, false);
      this.api.caret.setToBlock(index, "end");
    });

    return this.button;
  }

  surround() {}
  checkState() {}
  clear() {}

  static get title() {
    return "Formatierung zurücksetzen";
  }

  static get sanitize() {
    return {
      text: true,
    };
  }
}
